"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonFormInput = void 0;
const React = require("react");
const form_validations_1 = require("../../../utils/validations/form-validations");
const form_utils_1 = require("../../../utils/form.utils");
const BronsonFormInput = (props) => {
    const [hasError, setError] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState([]);
    const [previousSelectorStart, setPreviousSelectorStart] = React.useState();
    const [previousKeyCode, setPreviousKeyCode] = React.useState();
    const inputRef = React.useRef(null);
    React.useEffect(() => {
        if (inputRef && inputRef.current) {
            inputRef.current.value = props.defaultValue;
            if (previousSelectorStart && !props.isPhoneNumber) {
                inputRef.current.selectionEnd = previousSelectorStart;
            }
        }
        if (props.autoFill && inputRef.current && props.defaultValue) {
            const event = {
                currentTarget: {
                    value: props.defaultValue,
                },
            };
            (0, form_utils_1.handleChange)(event, errorMessage, setErrorMessage, setError, props.onKeyDown, props.validations, props.isUpperCase, props.isPhoneNumber, props.minLength, props.language);
        }
    }, [props.defaultValue]);
    React.useEffect(() => {
        if (props.hasError) {
            if (hasError !== props.hasError)
                setError(props.hasError);
        }
        else {
            setError(false);
        }
    }, [props.hasError]);
    const handleKeydown = (event) => {
        const eight = 8;
        const thirtyTwo = 32;
        const fortySix = 46;
        const eightySix = 86;
        const oneHundredTen = 110;
        const oneHundredNinety = 190;
        if (props.type === 'number' &&
            !(event.keyCode === eight ||
                event.keyCode === fortySix ||
                (event.keyCode === oneHundredNinety &&
                    !event.currentTarget.value.includes('.') &&
                    previousKeyCode !== oneHundredNinety &&
                    previousKeyCode !== oneHundredTen) ||
                (event.keyCode === oneHundredTen &&
                    !event.currentTarget.value.includes('.') &&
                    previousKeyCode !== oneHundredTen &&
                    previousKeyCode !== oneHundredNinety) ||
                (event.keyCode === eightySix &&
                    (event.metaKey || event.ctrlKey)) ||
                (event.keyCode !== thirtyTwo && (0, form_validations_1.isNumber)(event.key)))) {
            event.preventDefault();
        }
        else {
            setPreviousKeyCode(event.keyCode);
        }
        if (props.onKeyDown) {
            (0, form_utils_1.handleChange)(event, errorMessage, setErrorMessage, setError, props.onKeyDown, props.validations, props.isUpperCase, props.isPhoneNumber, props.minLength, props.language);
        }
    };
    const handleBlur = (event) => {
        if (props.onBlur) {
            (0, form_utils_1.handleChange)(event, errorMessage, setErrorMessage, setError, props.onBlur, props.validations, props.isUpperCase, props.isPhoneNumber, props.minLength, props.language);
        }
    };
    const inputId = (0, form_utils_1.generateElementId)(props.elementId);
    return (React.createElement(React.Fragment, null,
        props.label &&
            (0, form_utils_1.renderLabel)(props.label, props.validations, props.tooltip, inputId),
        React.createElement("div", { className: `c-input ${props.wrapperClassModifier ? props.wrapperClassModifier : ''}` },
            React.createElement("input", { className: `c-input__input ${props.hasError || hasError || errorMessage.length
                    ? 'is-error'
                    : ''} ${props.elementClassModifier
                    ? props.elementClassModifier
                    : ''} ${props.isUpperCase ? 'u-text-uppercase' : ''}`, id: inputId, type: props.type ? props.type : 'text', placeholder: props.placeholder, onChange: (event) => {
                    var _a;
                    if (event.currentTarget.value &&
                        event.currentTarget.value.trim() === '') {
                        inputRef.current.value = '';
                    }
                    setPreviousSelectorStart((_a = event.target) === null || _a === void 0 ? void 0 : _a.selectionStart);
                    (0, form_utils_1.handleChange)(event, errorMessage, setErrorMessage, setError, props.onChange, props.validations, props.isUpperCase, props.isPhoneNumber, props.minLength, props.language, props.startsWith);
                }, onKeyDown: handleKeydown, onPaste: (event) => {
                    if (props.pasting === false) {
                        event.preventDefault();
                    }
                    else if (props.type === 'number') {
                        if (!(0, form_validations_1.isNumber)(event.clipboardData.getData('Text'))) {
                            setError(true);
                            setErrorMessage([
                                'No es posible pegar un valor inválido',
                            ]);
                            event.preventDefault();
                        }
                        else {
                            setError(false);
                            setErrorMessage([]);
                        }
                    }
                }, onBlur: handleBlur, maxLength: props.maxLength, minLength: props.minLength, disabled: props.isDisabled, autoComplete: props.autocomplete || 'on', ref: inputRef }),
            props.searchButton ? (React.createElement("button", { id: `${inputId}-btn`, className: `c-input__addon  c-input__addon${props.searchButtonBackground === true
                    ? ''
                    : '--no-background'}`, onClick: () => props.searchButton && props.searchButton() },
                React.createElement("i", { className: 'c-icon  c-icon--[semantic-search]', "aria-hidden": 'true', role: 'img' }))) : (React.createElement(React.Fragment, null)),
            props.children),
        (0, form_utils_1.renderError)(hasError, errorMessage, props.hasError, props.errorMessage)));
};
exports.BronsonFormInput = BronsonFormInput;
